import React, { useEffect, useId, useState } from 'react';
import Modal from './Modal';
import { authApi } from '../api/auth';
import { formatApiError } from '../utils/errorUtils';

interface ChangePasswordModalProps {
  open: boolean;
  onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ open, onClose }) => {
  const formId = useId();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setCurrent('');
      setNext('');
      setConfirm('');
      setError('');
    }
  }, [open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== confirm) {
      setError('Parolele noi nu coincid');
      return;
    }
    if (next.length < 8) {
      setError('Parola nouă trebuie să aibă cel puțin 8 caractere');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await authApi.changePassword({ current_password: current, new_password: next });
      onClose();
    } catch (err: any) {
      setError(formatApiError(err.response?.data?.detail) || 'Eroare la schimbarea parolei');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Schimbă parola"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
            Anulează
          </button>
          <button type="submit" form={formId} className="btn btn-primary" disabled={saving}>
            {saving ? 'Se salvează…' : 'Actualizează parola'}
          </button>
        </>
      }
    >
      <form id={formId} onSubmit={handleSubmit}>
        {error && <div className="alert alert-error" style={{ marginBottom: 'var(--sp-4)' }}>{error}</div>}
        <div className="form-group">
          <label className="form-label" htmlFor="pw-current">
            Parola curentă
          </label>
          <input
            id="pw-current"
            className="form-input"
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="pw-new">
            Parola nouă
          </label>
          <input
            id="pw-new"
            className="form-input"
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="pw-confirm">
            Confirmă parola nouă
          </label>
          <input
            id="pw-confirm"
            className="form-input"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
        </div>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;
